<template>
  <section v-if="offers?.length" :id="data?.anchor_id ? data.anchor_id : null" class="accommodationOffer defaultSectionPaddings defaultSectionMargins" :class="{'singleOffer': offers.length === 1}">
    <div class="container">
      <h2 v-html="data.title" />

      <FlickitySlider class="accommodationOffer__Slider mediumArrows" :options="flickityOptions" :with-progress="true" :min-number-of-slides="3">
        <div v-for="item in offers" class="accommodationOffer__Item">
          <div class="accommodationOffer__ImagesWrapper">
            <FlarePicture
              class="accommodationOffer__MainImage"
              :src="{
                1920: { src: item.image, width: 550, height: 355, size: 'both', crop: 'fill' },
              }"
              :alt="item.image"
            />

            <img v-if="item.image_document_discount?.meta?.format === 'svg' && item.image_document_discount.meta.url" class="accommodationOffer__DiscountImage" :src="item.image_document_discount.meta.url" :alt="item.image_document_discount.title || ''" width="250" height="150" />
          </div>
          <div class="accommodationOffer__Content">
            <div class="accommodationOffer__Dates">{{ formatDate(item.travel_date_from) }} - {{ formatDate(item.travel_date_to) }}</div>

            <div>
              <h3 v-text="item.title" />
              <p v-text="item.subtitle" />
            </div>
          </div>
          <nuxt-link :to="item.sef">{{ item.title }}</nuxt-link>
        </div>
      </FlickitySlider>
    </div>
  </section>
</template>

<script setup>
  defineProps({
    data: {}
  })

  const { page } = usePage();
  const offers = ref([]);

  async function getOffers() {
    if (!page.value.id) return;
    try {
      const response = await useServerFetch('offer/', {
        params: {
          accommodation: page.value.id,
        }
      })
  
      if (response?.results) offers.value = response.results;
    } catch(error) {
      console.error(error)
    }
  }

  await getOffers();

  const flickityOptions = {
    pageDots: false,
    contain: true,
    cellAlign: 'left',
  };
</script>

<style lang="scss">
  @import url('@/assets/styles/components/blocks/_accommodationOffer.scss');
</style>